
import { switchMap } from 'rxjs/operators';
import {
  Component,
  OnInit,
  OnDestroy
} from '@angular/core';

import {
  ActivatedRoute
} from '@angular/router';

import { FileService } from '../../services/file.service';
import { PIDService } from '../../services/pid.service';
import { ProfileService } from '../../services/profile.service';
import { UserService } from '../../services/user.service';
import { NotificationService } from '../../services/notification.service';

import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'nestas-pid-transfer',
  templateUrl: './transfer.component.html',
  styleUrls: ['./transfer.component.scss']
})
export class TransferComponent implements OnInit, OnDestroy {
  pid = null;
  files = [];
  error = null;
  success = null;
  profile = null;
  newPassword = null;
  confirmPassword = null;
  updateProfileToken = null;
  transferPIDToken = null;
  agreed = false;
  transferPending = false;
  private _pidID;

  private _sub;

  constructor(private _route: ActivatedRoute, private _fileService: FileService, private _notification: NotificationService,
    private _pidService: PIDService, public translate: TranslateService, private _profileService: ProfileService, private _userService: UserService) {

  }

  passwordSecured() {
    return this._userService.passwordSecured(this.newPassword);
  }

  ngOnDestroy() {
    this._sub.unsubscribe();
  }

  ngOnInit() {
    this._sub = this._route.paramMap.subscribe(
      (params:any) => {
        this._pidID = params.get('id');
        this.transferPIDToken = params.get('token');

        console.log("params", params, this._pidID, this.transferPIDToken);
        return this._pidService.getTransferredPID(this._pidID, this.transferPIDToken)

          .subscribe(
            (ret: any) => {
              this.pid = ret.pid;
              this.profile = ret.profile;
              this.translate.use(this.profile.lang || 'nl');
              document.documentElement.setAttribute("lang", this.profile.lang || 'nl');
              this.updateProfileToken = ret.token;
              this._fileService.getForTransferredPID(this._pidID).subscribe(
                (files: any) => { this.files = files },
                err => {
                  this.error = err;
                  this._notification.errorServer(err);
                }
              );
            },
            err => {
              this.error = err;
              try{
                this._notification.errorServer(err);
              } catch {
                1;
              }
            }
          );
      });
  }

  informationComplete() {
    return (this.profile.firstname
      && this.profile.lastname
      && this.profile.address.address
      && this.profile.address.zip
      && this.profile.address.city
      && this.agreed
      && this.profile.address.country);
  }

  UpdateAndAcceptTransfer() {
    if (this.newPassword && !this.passwordSecured()) {
      this._notification.errorClient('MESSAGE.ERROR.UNSECURE_PASSWORD');
      return;
    }
    if (this.newPassword && this.newPassword != this.confirmPassword) {
      this._notification.errorClient(this.translate.instant('MESSAGE.NOT_MATCH', { data: this.translate.instant('DATA.PASSWORD') }));
      return;
    }
    if (!this.informationComplete()) {
      this._notification.errorClient('TRANSFER.PERSONAL_INFO_INCOMPLETE');
      return;
    }
    if (this.transferPending){
      return;
    }
    this.transferPending = true;
    this._profileService.updatePersonalInformations(this.updateProfileToken, this.profile, this.newPassword).subscribe(
      (ret: any) => {
        this._pidService.completeTransfer(this.pid._id, this.transferPIDToken).subscribe(
          (ret: any) => {
            window.location.assign(ret.url ? ret.url : "");
          },
          err => { this._notification.errorServer(err); }
        )
      },
      err => { this._notification.errorServer(err); }
    );
  }
}
